import axios from "axios"



const httpApi = axios.create({
  baseURL: '/wp-json/questionnaire-api',
  timeout: 60000, // 60 sekund
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'responseType': 'json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'X-WP-Nonce': typeof questionnaireData != 'undefined' ? questionnaireData.nonce : ''
  },
  withCredentials: true,
  responseType: 'json'
})


export default httpApi